import { useStaticQuery, graphql } from 'gatsby';

const useSuccessStoryImages = () => {
  const { allContentfulWebsiteImage } = useStaticQuery(
    graphql`
      query {
        allContentfulWebsiteImage(
          filter: {
            internalName: {
              in: [
                "Success Story 1"
                "Success Story 2"
                "Success Story 3"
                "Success Story 4"
                "Success Story 5"
                "Success Story 6"
                "Success Story 7"
                "Success Story 8"
              ]
            }
          }
        ) {
          edges {
            node {
              contentful_id
              internalName
              alt
              image {
                fluid(quality: 100) {
                  ...GatsbyContentfulFluid_withWebp_noBase64
                }
                file {
                  url
                }
              }
            }
          }
        }
      }
    `
  );
  return allContentfulWebsiteImage.edges;
};

export default useSuccessStoryImages;
